var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner",class:{ 'spinner-block': _vm.block, 'spinner-sm': _vm.small, 'show': _vm.shown }},[_c('div',{staticClass:"spinner-bar"}),(_vm.messageNotEmpty)?_c('div',{staticClass:"spinner-text"},[_vm._v(_vm._s(_vm.message))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }